import React from 'react';

import {TimeSeriesVariables} from 'src/lib/api/series';
import COLORS from 'src/lib/colors';
import {Dims} from 'src/lib/commonTypes';

import {YScale} from './D3Axis';
import {useTranslations} from './TranslationsContext';

type Props = {
  y: YScale;
  graphDims: Dims;
  temperatureTimeSeries: {variables: TimeSeriesVariables};
};

export function FreezingLine({graphDims, y, temperatureTimeSeries}: Props) {
  const {t} = useTranslations();
  if (!temperatureTimeSeries) {
    return null;
  }

  const freezingTemperature = temperatureTimeSeries.variables.temperature?.unit === '°C' ? 0 : 32;

  // temperatures are likely high and there's no room on the plot for us.
  const yPos = y(freezingTemperature);
  if (yPos > graphDims[1] || yPos < 0) {
    return null;
  }

  return (
    <g className="sharp">
      <text
        fontSize={10}
        x={graphDims[0] - 4}
        y={y(freezingTemperature) - 6}
        textAnchor="end"
        fill={COLORS.AXIS}
      >
        {t('freezing')}
      </text>
      <line
        x1={0}
        x2={graphDims[0]}
        y1={y(freezingTemperature)}
        y2={y(freezingTemperature)}
        stroke={COLORS.AXIS}
        strokeOpacity={0.5}
      />
    </g>
  );
}
